import { useTranslation } from 'react-i18next'
import { Text, IconCheckCircleOutline, TextLinkButton } from '@machobear/design-system'
import { InsightBlock } from '../insight-block'
import { useListingDashboardModals } from '../../../modals'

export const PastSponsor = () => {
  const { t } = useTranslation()
  const { showModal } = useListingDashboardModals()

  return (
    <InsightBlock
      testId="boost-listing"
      icon={<IconCheckCircleOutline tone="positive" size="small" />}
    >
      <Text size="medium" weight="medium">
        {t('Boost your listing')}
      </Text>
      <Text>
        {t('You’ve previously sponsored this listing.')}&nbsp;
        <TextLinkButton onClick={showModal('sponsoredListing')} weight="regular">
          {t('Boost again')}
        </TextLinkButton>
      </Text>
    </InsightBlock>
  )
}
